import { WhiteBalanceIridescentIcon } from './WhiteBalanceIridescentIcon';

/**
 * author: Google
 * id E88B06D9-C60D-4084-9AE9-742266F0E8FB
 * name white-balance-iridescent
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/white-balance-iridescent.svg
 * tags
 * - Photography 
 */
export const WbIridescentIcon = WhiteBalanceIridescentIcon;
export default WbIridescentIcon